module.exports = __webpack_public_path__ + "media/src/img/payment/wm-de6a63893d8ca5a23d1c139bdd228dce.png";